// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewentrantSendoffState, workerData, Educator } from 'types';
import {
  getNewentrantEducation,
  getEducationStatus,
  getUpperCooperatorList,
  getSendoffEducation,
  educationNewentrantRegister,
  educationSendoffRegister,
} from './thunk';

const initialState: NewentrantSendoffState = {
  workerDatas: [
    {
      users_id: 0,
      cooperator_code: '',
      worker_name: '',
      site_id: 0,
      site_code: '',
    },
  ],
  loading: false,
  newcomer_education_status: 0,
  sendoff_education_status: 0,
  newentrantEducation: {
    genba_no: '',
    genba_name: '',
    genba_address: '',
    kouki: '',
    structure: '',
    work_time: '',
    safety_slogan: '',
    safety_measures_title: '',
    safety_measures: '',
    observance__title: '',
    observance: '',
    new_admission: '',
    first_gyosya_name: '',
    gyosya_name: '',
    worker_name: '',
    worker_name_kana: '',
    one_person_chief_name: '',
    accident_insurance_status: '',
    age: 0,
    birth_date: '',
    blood_type_name: '',
    health_check_date: '',
    special_health: {
      special_health_check_date: '',
      special_health_check_name: '',
    },
    blood_pressure: '',
    emergency: {
      emergency_name: '',
      emergency_relationship_name: '',
      emergency_phone_number: '',
    },
    home_address: '',
    phone_number: '',
    chronic_disease_flg: '',
    visa_status_kbn: '',
    nationality_flg: 0,
    educator: {
      educator_flg: '',
      cooperator_code: '',
      cooperator_name: '',
      user_name: '',
    },
    updateNotCheckBox: 0,
  },
  upperCooperatorList: {
    educator_cooperator_list: [
      {
        cooperator_id: '',
        cooperator_code: '',
        cooperator_name: '',
      },
    ],
  },
  sendoffEducation: {
    genba_no: '',
    genba_name: '',
    genba_address: '',
    kouki: '',
    structure: '',
    gyosya_name: '',
    first_gyosya_name: '',
    worker_name: '',
    worker_name_kana: '',
    sex_name: '',
    birth_date: '',
    age: 0,
    blood_type_name: '',
    job_category_name: '',
    experience_years: '',
    home_address: '',
    phone_number: '',
    emergency: {
      emergency_address: '',
      emergency_phone_number: '',
      emergency_name: '',
      emergency_relationship_name: '',
      mail_address: '',
    },
    employment_kbn: '',
    employment_name: '',
    employment_insurance_flg: '',
    employment_insurance_name: '',
    accident_insurance_flg: '',
    health_check_date: '',
    blood_pressure: '',
    special_health: {
      special_health_check_date: '',
      special_health_check_name: '',
    },
    compliance_title: '',
    compliance_list: [
      {
        compliance_content: '',
        compliance_check: '',
      },
    ],
    medical_history_else: '',
    medical_history_flg: '',
    work_limit_flg: '',
    work_limit_reason: '',
    emergency_report_check: '',
    medical_history_list: [
      {
        medical_history_content: '',
        medical_history_code: 0,
        medical_history_check: '',
      },
    ],
    educator: undefined,
    updateNotCheckBox: 0,
  },
  num: 0,
  educationSendStatus: {
    send_flg: 0,
  },
};

export const newentrantSendoffSlice = createSlice({
  name: 'newentrantSendoffSlice',
  initialState,
  reducers: {
    setWorkerDatas: (state, action: PayloadAction<workerData[]>) => {
      state.workerDatas = action.payload;
    },
    setSendFlg: (state, action: PayloadAction<{ send_flg: number }>) => {
      state.educationSendStatus.send_flg = action.payload.send_flg;
    },
    setNum: (state, action: PayloadAction<{ num: number }>) => {
      state.num = action.payload.num;
    },
    setNewentrantUpdateNotCheckBox: (
      state,
      action: PayloadAction<{ updateNotCheckBox: number }>
    ) => {
      state.newentrantEducation.updateNotCheckBox = action.payload.updateNotCheckBox;
    },
    setSendoffUpdateNotCheckBox: (state, action: PayloadAction<{ updateNotCheckBox: number }>) => {
      state.sendoffEducation.updateNotCheckBox = action.payload.updateNotCheckBox;
    },
    setCooperator: (state, action: PayloadAction<Educator>) => {
      state.newentrantEducation.educator.educator_flg = action.payload.educator_flg;
      state.newentrantEducation.educator.cooperator_code = action.payload.cooperator_code;
      state.newentrantEducation.educator.cooperator_name = action.payload.cooperator_name;
    },
  },
  extraReducers(builder) {
    builder.addCase(getEducationStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEducationStatus.fulfilled, (state, action) => {
      state.newcomer_education_status = action.payload.newcomer_education_status;
      state.sendoff_education_status = action.payload.sendoff_education_status;
      state.loading = false;
    });
    builder.addCase(getEducationStatus.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getNewentrantEducation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNewentrantEducation.fulfilled, (state, action) => {
      state.newentrantEducation.genba_no = state.workerDatas
        ? state.workerDatas[state.num].site_code
        : '';
      state.newentrantEducation.genba_name = action.payload.genba_name;
      state.newentrantEducation.genba_address = action.payload.genba_address;
      state.newentrantEducation.kouki = action.payload.kouki;
      state.newentrantEducation.structure = action.payload.structure;
      state.newentrantEducation.work_time = action.payload.work_time;
      state.newentrantEducation.observance__title = action.payload.observance__title;
      state.newentrantEducation.observance = action.payload.observance;
      state.newentrantEducation.first_gyosya_name = action.payload.first_gyosya_name;
      state.newentrantEducation.gyosya_name = action.payload.gyosya_name;
      state.newentrantEducation.worker_name_kana = action.payload.worker_name_kana;
      state.newentrantEducation.worker_name = action.payload.worker_name;
      state.newentrantEducation.one_person_chief_name = action.payload.one_person_chief_name;
      state.newentrantEducation.accident_insurance_status =
        action.payload.accident_insurance_status;
      state.newentrantEducation.age = action.payload.age;
      state.newentrantEducation.birth_date = action.payload.birth_date;
      state.newentrantEducation.blood_type_name = action.payload.blood_type_name;
      state.newentrantEducation.health_check_date = action.payload.health_check_date;
      state.newentrantEducation.special_health = {
        special_health_check_date: action.payload.special_health_check_date,
        special_health_check_name: action.payload.special_health_check_name,
      };
      state.newentrantEducation.blood_pressure =
        action.payload.blood_pressure_low + '～' + action.payload.blood_pressure_high;
      state.newentrantEducation.emergency = {
        emergency_name: action.payload.emergency_name,
        emergency_relationship_name: action.payload.emergency_relationship_name,
        emergency_phone_number: action.payload.emergency_phone_number,
      };
      state.newentrantEducation.home_address = action.payload.home_address;
      state.newentrantEducation.phone_number = action.payload.phone_number;
      state.newentrantEducation.chronic_disease_flg = ''; // (0：無、1：有);
      state.newentrantEducation.visa_status_kbn = ''; // (0：未確認、1：確認済み);
      state.newentrantEducation.nationality_flg = action.payload.nationality_flg; // (0：日本籍、1：外国籍);
      state.newentrantEducation.educator = {
        educator_flg: '', // (0：大東建託、1：それ以外);
        cooperator_code: '',
        cooperator_name: '',
        user_name: '',
      };

      state.loading = false;
    });
    builder.addCase(getNewentrantEducation.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getUpperCooperatorList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUpperCooperatorList.fulfilled, (state, action) => {
      state.upperCooperatorList = action.payload;
      state.loading = false;
    });
    builder.addCase(getUpperCooperatorList.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getSendoffEducation.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getSendoffEducation.fulfilled, (state, action) => {
      state.sendoffEducation.genba_no = state.workerDatas
        ? state.workerDatas[state.num].site_code
        : '';
      state.sendoffEducation.genba_name = action.payload.genba_name;
      state.sendoffEducation.genba_address = action.payload.genba_address;
      state.sendoffEducation.kouki = action.payload.kouki;
      state.sendoffEducation.structure = action.payload.structure;
      state.sendoffEducation.compliance_title = action.payload.compliance_title;
      state.sendoffEducation.compliance_list = action.payload.compliance_list.map((item) => ({
        compliance_content: item.compliance_content,
        compliance_check: '0',
      }));
      state.sendoffEducation.first_gyosya_name = action.payload.first_gyosya_name;
      state.sendoffEducation.gyosya_name = action.payload.gyosya_name;
      state.sendoffEducation.worker_name_kana = action.payload.worker_name_kana;
      state.sendoffEducation.worker_name = action.payload.worker_name;
      state.sendoffEducation.sex_name = action.payload.sex_name;
      state.sendoffEducation.birth_date = action.payload.birth_date;
      state.sendoffEducation.age = action.payload.age;
      state.sendoffEducation.blood_type_name = action.payload.blood_type_name;
      state.sendoffEducation.job_category_name = action.payload.job_category_name;
      state.sendoffEducation.experience_years = action.payload.experience_years;
      state.sendoffEducation.home_address = action.payload.home_address;
      state.sendoffEducation.phone_number = action.payload.phone_number;
      state.sendoffEducation.emergency = {
        emergency_address: action.payload.emergency_address,
        emergency_phone_number: action.payload.emergency_phone_number,
        emergency_name: action.payload.emergency_name,
        emergency_relationship_name: action.payload.emergency_relationship_name,
        mail_address: action.payload.mail_address,
      };
      state.sendoffEducation.employment_name = action.payload.employment_name;
      state.sendoffEducation.employment_insurance_name = action.payload.employment_insurance_name;
      state.sendoffEducation.health_check_date = action.payload.health_check_date;
      state.sendoffEducation.blood_pressure =
        action.payload.blood_pressure_low + '～' + action.payload.blood_pressure_high;
      state.sendoffEducation.special_health = {
        special_health_check_date: action.payload.special_health_check_date,
        special_health_check_name: action.payload.special_health_check_name,
      };
      state.sendoffEducation.medical_history_flg = ''; //（（0：ない、1：あり）;
      state.sendoffEducation.medical_history_list = action.payload.medical_history_list?.map(
        (item) => ({
          medical_history_content: item.medical_history_content,
          medical_history_code: item.medical_history_code,
          medical_history_check: '0', //（（0：チェック無し、1：チェック有り）;
        })
      );
      state.sendoffEducation.medical_history_else = '';
      state.sendoffEducation.work_limit_flg = ''; //（(0：できる、1：できない);
      state.sendoffEducation.work_limit_reason = '';
      state.sendoffEducation.emergency_report_check = '0'; //（0：チェック無し、1：チェック有り）;
      state.sendoffEducation.educator = {
        user_name: '',
      };

      state.loading = false;
    });

    builder.addCase(getSendoffEducation.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(educationNewentrantRegister.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(educationNewentrantRegister.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(educationNewentrantRegister.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(educationSendoffRegister.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(educationSendoffRegister.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(educationSendoffRegister.rejected, (state) => {
      state.loading = false;
    });
  },
});
export const { actions, reducer } = newentrantSendoffSlice;
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
